import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PistachioImg from '../assets/banners/pistachios.jpg';
import { FaSeedling, FaHeart, FaGlobe, FaBoxOpen } from 'react-icons/fa';

const Pistachios = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Pistachio Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your pistachios.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-lime-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-lime-700 mb-4">Premium Pistachios</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Crunchy, nutrient-rich pistachios sourced from premium farms — perfect for snacking, sweets, and global distribution.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={PistachioImg}
                        alt="Pistachios"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-lime-700 mb-6">Why Choose Our Pistachios?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaHeart className="text-lime-600 mt-1" />Rich in healthy fats, antioxidants & heart-friendly nutrients</li>
                        <li className="flex items-start gap-3"><FaSeedling className="text-lime-600 mt-1" />Naturally grown & sun-dried with no chemicals</li>
                        <li className="flex items-start gap-3"><FaBoxOpen className="text-lime-600 mt-1" />Variants: In-shell, Roasted, Salted, Pistachio Kernels</li>
                        <li className="flex items-start gap-3"><FaGlobe className="text-lime-600 mt-1" />Ideal for snacking, bakery, confectionery & exports</li>
                        <li className="flex items-start gap-3"><FaHeart className="text-lime-600 mt-1" />Packed hygienically to retain freshness</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-lime-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-lime-700 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-lime-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-lime-200">
                                    <th className="p-4 text-left bg-lime-100">Variants</th>
                                    <td className="p-4">In-Shell Roasted, Salted, Raw, Kernel</td>
                                </tr>
                                <tr className="border-b border-lime-200">
                                    <th className="p-4 bg-lime-100">Origin</th>
                                    <td className="p-4">Iran, USA, India (Kashmir)</td>
                                </tr>
                                <tr className="border-b border-lime-200">
                                    <th className="p-4 bg-lime-100">Shelf Life</th>
                                    <td className="p-4">12 months</td>
                                </tr>
                                <tr className="border-b border-lime-200">
                                    <th className="p-4 bg-lime-100">Packaging</th>
                                    <td className="p-4">250g, 500g, 1kg, 5kg, 10kg Box / Vacuum Packs</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-lime-100">Moisture</th>
                                    <td className="p-4">Below 6%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-lime-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-lime-200">
                                    <th className="p-4 text-left bg-lime-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 560 kcal<br />
                                        Protein: 20g<br />
                                        Fat: 45g<br />
                                        Carbs: 28g<br />
                                        Fiber: 10g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-lime-100">Usage</th>
                                    <td className="p-4">
                                        Snacking, Sweets, Confectionery, Desserts, Ice Creams, Gifting
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaHeart className="text-4xl mx-auto text-lime-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Heart-Healthy</h4>
                </div>
                <div>
                    <FaSeedling className="text-4xl mx-auto text-lime-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Naturally Grown</h4>
                </div>
                <div>
                    <FaGlobe className="text-4xl mx-auto text-lime-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Global Shipping</h4>
                </div>
                <div>
                    <FaBoxOpen className="text-4xl mx-auto text-lime-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Secure Packaging</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-lime-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-lime-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-lime-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-lime-600 hover:bg-lime-700 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Pistachios;
